import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import { hideAppInstall, usePopupSliceSelector } from '../../store/modules/popup';
import PopUp from './PopUp';
import MobileSymbol from '../../img/symbol_mobile.png';
import MobileSymbol2x from '../../img/symbol_mobile@2x.png';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { movePOClientDownloadURL } from '../../utils/util';
import { useAppDataSliceSelector } from '../../store/modules/appData';
import ga from '../../utils/gaConnect';
import { genAniSelector, verticalSlideGenerator } from '../common/AnimationCommon';
import useDelayHiding from '../../hooks/delayHidingHook';

const slideDown = verticalSlideGenerator('-100%', '0px');
const slideUp = verticalSlideGenerator('0px', '-100%');

const Position = css`
  left: 0px;
  top: 0px;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  //animation-duration: 1.5s;
  //animation-name: ${slideDown};

  ${genAniSelector(slideDown, slideUp, 1500, 700)}
`;
const ContentsWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
`;

const SymbolArea = styled.div`
  width: 80px;
  padding-top: 22px;
  padding-right: 18px;
  padding-left: 16px;
  box-sizing: border-box;
`;

const ContentsArea = styled.div`
  display: flex;
  flex-direction: column;
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 18px;
`;

const MobileTextAreaTitle = styled.div`
  height: 44px;
  padding-top: 22px;
  font-size: 16px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  box-sizing: border-box;
`;

const MobileTextAreaContents = styled.div`
  padding-top: 8px;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

const ButtonArea = styled.div`
  display: flex;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 18px;
  justify-content: flex-end;
`;

export default function PopUpAppInstall() {
  const { t, i18n } = useTranslation();
  const popupSelector = usePopupSliceSelector();
  const appData = useAppDataSliceSelector();
  const dispatch = useDispatch();

  const renderable = useDelayHiding(popupSelector.appInstall.isShow, { duration: 700 });

  const isShareView = appData.shareId !== '';

  const moveInstallLink = () => {
    ga.event({
      category: '모바일 앱',
      action: 'Polaris Office 앱 다운로드',
      label: '상단알림'
    });
    movePOClientDownloadURL({ appData, lang: i18n.language });
  };

  const closePopUp = () => {
    let gaData = { category: '모바일 앱', action: '상단알림닫기' };
    if (isShareView) gaData.label = '공유뷰';
    ga.event(gaData);
    dispatch(hideAppInstall());
  };

  return (
    renderable && (
      <PopUp cssExt={Position} isShow={popupSelector.appInstall.isShow}>
        <ContentsWrapper>
          <SymbolArea>
            <img
              width="48px"
              height="40px"
              src={MobileSymbol}
              srcSet={MobileSymbol2x}
              alt="po symbol"
            />
          </SymbolArea>
          <ContentsArea>
            <TextArea>
              <MobileTextAreaTitle>{t('AppInstallPopUp.Title')}</MobileTextAreaTitle>
              <MobileTextAreaContents>{t('AppInstallPopUp.Contents')}</MobileTextAreaContents>
            </TextArea>
            <ButtonArea>
              <Button
                cssExt={css`
                  min-width: 100px;
                  font-weight: 400;
                  color: #1d7ff9;
                  border: none;
                  font-size: 14px;
                  height: 36px;
                  margin-right: 12px;
                `}
                onClick={closePopUp}>
                {t('Common.Afterwards')}
              </Button>
              <Button
                primary
                cssExt={css`
                  min-width: 100px;
                  font-weight: 400;
                  font-size: 14px;
                  height: 36px;
                `}
                onClick={moveInstallLink}>
                {t('Common.AppDownload')}
              </Button>
            </ButtonArea>
          </ContentsArea>
        </ContentsWrapper>
      </PopUp>
    )
  );
}
